import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import globalStyles from '../index.less';
import { track } from '@utils';
import { CLICK_SAVED_DASHBOARD_TABS } from '@src/utils/sensor/track';

const { baseUrl } = window.conviva;

const onTabClick = () => {
  track({
    event: CLICK_SAVED_DASHBOARD_TABS,
  });
};

const SavedDashboardsTab = () => (
  <NavLink
    id="tab-saved-dashboards"
    key="saveddashboards"
    to={`${baseUrl}/dashboard/saved-dashboards`}
    className={({ isActive }) => classnames(globalStyles.tab, { [globalStyles.active]: isActive })}
  >
    <div onClick={onTabClick}>Saved Dashboards</div>
  </NavLink>
);

export default SavedDashboardsTab;
